/* Related
======================================== */
$.fn.shuffle = function(){
	let items = this.get();
	let shuffled = $.map(items, function(){
		let random = Math.floor(Math.random()*items.length);
		let item = $(items[random]).clone(true)[0];
		items.splice(random, 1);
		return item;
	});
	this.each(function(i){
		$(this).replaceWith($(shuffled[i]));
	});
	return $(shuffled);
};

// Shuffle
$('.module-products').each(function(){
	let t = $(this);
	if(t.find('.product').length > 8){
		t.find('.product').shuffle();
		t.find('.product:nth-child(8)').nextAll().remove();
	}
});